import script from "./AdministrativeData.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdministrativeData.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__